import { render, staticRenderFns } from "./FamilyTextsPane.vue?vue&type=template&id=b4bb7f2e&scoped=true&"
import script from "./FamilyTextsPane.vue?vue&type=script&lang=ts&"
export * from "./FamilyTextsPane.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyTextsPane.vue?vue&type=style&index=0&id=b4bb7f2e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bb7f2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardActions,VCardSubtitle,VCardText,VCardTitle,VCol,VForm,VIcon,VRow,VSpacer,VTooltip})
